import { useMemo } from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonBadge from "components/ArgonBadge";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button, Chip } from "@mui/material";
import { Link } from "react-router-dom";

const columns = [
  { name: "sno", align: "center" },
  { name: "Subjects", align: "left" },
  { name: "Board", align: "left" },
  { name: "Classes", align: "left" },
];

const TeachingPreferenceTableData = (tutor) => {
  const rows = useMemo(() => {
    if (!tutor) return [];

    const subjects = tutor.subjects || [];
    const boards = tutor.boards || [];
    const classes = tutor.classes || [];

    // Show all data in a single row
    return [
      {
        sno: (
          <ArgonTypography variant="caption" fontWeight="medium" color="text">
            {1}
          </ArgonTypography>
        ),
        Subjects: (
          <ArgonBox display="flex" flexWrap="wrap" gap={0.5}>
            {subjects.length > 0 ? (
              subjects.map((subject, idx) => (
                <Chip
                  key={idx}
                  label={subject?.name}
                  size="small"
                  sx={{
                    backgroundColor: "#e3f2fd",
                    fontSize: "0.75rem",
                  }}
                />
              ))
            ) : (
              <ArgonTypography variant="caption" color="text">
                N/A
              </ArgonTypography>
            )}
          </ArgonBox>
        ),
        Board: (
          <ArgonBox display="flex" flexWrap="wrap" gap={0.5}>
            {boards.length > 0 ? (
              boards.map((board, idx) => (
                <Chip
                  key={idx}
                  label={board?.name}
                  size="small"
                  sx={{
                    backgroundColor: "#f3e5f5",
                    color: "#7b1fa2",
                    fontSize: "0.75rem",
                  }}
                />
              ))
            ) : (
              <ArgonTypography variant="caption" color="text">
                N/A
              </ArgonTypography>
            )}
          </ArgonBox>
        ),
        Classes: (
          <ArgonBox display="flex" flexWrap="wrap" gap={0.5}>
            {classes.length > 0 ? (
              classes.map((cls, idx) => (
                <Chip
                  key={idx}
                  label={cls?.name}
                  size="small"
                  sx={{
                    backgroundColor: "#e8f5e9",
                    color: "#388e3c",
                    fontSize: "0.75rem",
                  }}
                />
              ))
            ) : (
              <ArgonTypography variant="caption" color="text">
                N/A
              </ArgonTypography>
            )}
          </ArgonBox>
        ),
      },
    ];
  }, [tutor]);

  return { columns, rows };
};

export default TeachingPreferenceTableData;

// /* eslint-disable react/prop-types */
// // Argon Dashboard 2 MUI components
// import ArgonBox from "components/ArgonBox";
// import ArgonTypography from "components/ArgonTypography";
// import ArgonAvatar from "components/ArgonAvatar";
// import ArgonBadge from "components/ArgonBadge";
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import DeleteIcon from '@mui/icons-material/Delete';

// // Images
// import team2 from "assets/images/team-2.jpg";
// import team3 from "assets/images/team-3.jpg";
// import team4 from "assets/images/team-4.jpg";
// import { Button } from "@mui/material";
// import { Link } from "react-router-dom";

// function Author({ image, name, email }) {

//   return (
//     <ArgonBox display="flex" alignItems="center" px={0.5} py={0.1}>
//       <ArgonBox mr={2}>
//         <ArgonAvatar src={image} alt={name} size="sm" variant="rounded"/>
//       </ArgonBox>
//       <ArgonBox display="flex" flexDirection="column">
//         <ArgonTypography textTransform="none" variant="button" fontWeight="medium">
//           {name}
//         </ArgonTypography>
//         <ArgonTypography variant="caption" color="secondary">
//           {email}
//         </ArgonTypography>
//       </ArgonBox>
//     </ArgonBox>
//   );
// }

// const TeachingPreferenceTableData = {
//   columns: [

//     {name:"sno",align:"center"},
//     {name:"Subjects",align:"left"},
//     {name:"Board", align:"left"},
//     {name:"Classes",align:"left"},

//   ],

//   rows: [
//     {
//       sno:<ArgonTypography variant="caption" fontWeight="medium" color="text">{1}</ArgonTypography>,
//       "Category":<ArgonTypography variant="caption" fontWeight="medium" color="text">{"Mathematics"}</ArgonTypography>,
//       "Board": <ArgonTypography variant="caption" fontWeight="medium" color="text">{"CBSE"}</ArgonTypography>,
//       "Classes": <ArgonTypography variant="caption" fontWeight="medium" color="text">{"10th, 12th"}</ArgonTypography>,
//       "Answer": <ArgonTypography variant="caption" fontWeight="medium" color="text">{"Yes"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//       // action:( <ArgonTypography component="a" href="#"  variant="caption"  color="secondary" fontWeight="medium">  Edit </ArgonTypography>),
//        action: (
//        <ArgonBox display="flex" alignItems="center" gap={0}>
//            {/* View Icon */}
//             <Button variant="text"  size="large" component={Link} to="/tutors/profile" sx={{minWidth:"12px",p:0}} >
//               <VisibilityIcon color="primary"/>
//             </Button>
//             {/* Delete icon */}
//            <Button variant="text"  size="large" sx={{minWidth:"32px",p:0}}
//            onClick={() =>handleDeleteClick()} >
//              <DeleteIcon color="error"/>
//            </Button>

//          </ArgonBox>
//        ),
//     },
//   ],
// }

// export default TeachingPreferenceTableData;
